import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Sparkles, Loader2, ArrowLeft } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Selamat datang, Admin");
      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Gagal login");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#1C1917] flex items-center justify-center px-5">
      <div className="w-full max-w-md">
        <button
          onClick={() => navigate("/")}
          className="mb-6 inline-flex items-center gap-2 text-xs tracking-widest uppercase text-white/60 hover:text-[#C5A059]"
          data-testid="admin-back-home"
        >
          <ArrowLeft className="w-4 h-4" /> Kembali ke Website
        </button>
        <div className="bg-[#FFFDF9] rounded-3xl border border-[#E5D7C5] p-8 sm:p-10 shadow-2xl">
          <div className="flex items-center gap-2 mb-8">
            <Sparkles className="w-6 h-6 text-[#C5A059]" />
            <div>
              <div className="font-serif text-xl font-semibold text-[#1C1917]">
                Ascarya Dekorasi
              </div>
              <div className="font-mono text-[9px] tracking-[0.25em] uppercase text-[#967C52]">
                Admin Panel
              </div>
            </div>
          </div>

          <h1 className="font-serif text-2xl text-[#1C1917] mb-6">Masuk Admin</h1>

          <form onSubmit={submit} className="space-y-5">
            <div>
              <Label className="text-xs font-semibold tracking-widest uppercase text-[#967C52]">
                Email
              </Label>
              <Input
                className="mt-2"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@email.com"
                data-testid="admin-email-input"
                required
              />
            </div>
            <div>
              <Label className="text-xs font-semibold tracking-widest uppercase text-[#967C52]">
                Password
              </Label>
              <Input
                className="mt-2"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                data-testid="admin-password-input"
                required
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit"
              className="w-full inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-[#C5A059] text-white text-xs font-semibold tracking-widest uppercase hover:bg-[#A8833E] transition-all disabled:opacity-60"
            >
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Masuk"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
